import React, { useEffect, useRef, useState } from 'react'
import './player-market-landing.styles.scss'
import { switchPlayerMenu } from '../side-menu.component';
import { Route, Routes, useNavigate } from 'react-router-dom';
import PlayerStore from './player-store.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import PlayerTradePortal from './player-trade-portal.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCubesStacked, faDice, faExchange, faGift, faGlobeAmericas, faPiggyBank, faTicket } from '@fortawesome/free-solid-svg-icons';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import PlayerCollectibles from './player-collectibles.component';
import StoreButtonRow from './store-components/store-buttons.component';
import StoreButtons from './store-components/store-buttons.component';
import { useSelector } from 'react-redux';
import { getGameElementsFromDb } from '@/utils/getDataFromDb';
import ShoppingCart from './shopping-cart.component';

const PlayerMarketLanding = ({ 
    gameData, 
    playerData, 
    gameStats,
    teamMembers,
    myTeams,
    gameElements
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ itemType, setItemType ] = useState('inventory');
    const [ availableItems, setAvailableItems ] = useState([]);
    const [ collections, setCollections ] = useState([]);
    const [ saleList, setSaleList ] = useState([]);
    const navigate = useNavigate();
    const collectionRef = useRef();
    const marketRef = useRef([]);
    let collectionListener;
    let marketListener;
    
    useEffect(() => {
        const pageTitle = document.getElementById('page-title');
        if (pageTitle) {
            pageTitle.innerText = 'Shop the Marketplace'
        }
        switchPlayerMenu('store-btn');

        return () => {
            if (collectionListener) collectionListener();
            if (marketListener) marketListener();
        }
    }, []);

    useEffect(() => {
        if (!gameData || !playerData) return;
        // console.log(gameElements)
        // if (!gameElements || !gameData) return;

        // const availItems = Object.values(gameElements)
        // .filter(e => 
        //     (
        //         e.type === 'item' || 
        //         e.type === 'prizePack'
        //     ) && 
        //     e.status === 'active' && 
        //     e.opt_visible &&
        //     e.opt_market 
        // );
        // setAvailableItems(availItems);
        // console.log(availItems);
        getCollections();
        getMarketItems();
        getSales();
    }, [ gameData, playerData])

    function getSales() {
        // const now = new Date().getTime();
        // setSaleList(
        //     Object.values(gameElements)
        //     .filter(e => 
        //         e.type === 'sale' &&
        //         e.status === 'active' &&
        //         (!e.opt_dateOpen || e.opt_dateOpen < now) &&
        //         (!e.opt_dateClose || e.opt_dateClose > now)
        //     )
        //     .sort((a,b) => a.ts > b.ts ? 1 : -1)
        // )
    }

    function getCollections() {
        getGameElementsFromDb({
            "gameId": playerData.gameId,
            "elementType": "collection",
            "status": "active",
            "callback": callback,
            "handleListener": handleListener
        })
        function callback(data) {
            collectionRef.current = {
                ...collectionRef.current,
                ...{[data.id]: data}
            }
            setCollections(Object.values(collectionRef.current));
        }
        function handleListener(unsub) {
            collectionListener = unsub;
        }
    }

    function getMarketItems() {
        getGameElementsFromDb({
            "gameId": playerData.gameId,
            "elementType": "item",
            "market": true,
            "status": "active",
            "callback": callback,
            "handleListener": handleListener
        })
        function callback(data) {
            marketRef.current = {
                ...marketRef.current,
                ...{[data.id]: data}
            }
            setAvailableItems(Object.values(marketRef.current));
        }
        function handleListener(unsub) {
            marketListener = unsub;
        }
    }

    return (
        <div className={`player-market ${screenSize}`}>
            <Routes>
                <Route path='' element={
                    <div className='g-card market-card'>
                        {/* <BackButton cancel={() => navigate(-1)} /> */}
                        <div className='player-title'>
                            <ImageContainer src='/images/icons/shopping-cart.png' alt='marketplace icon' className='player-title-icon' />
                            Shop the Marketplace
                        </div>
                        <hr />
                        <div className='market-grid'>
                            <div className='button-col'>
                            {
                                (availableItems && gameData) &&
                                <StoreButtons
                                    allItems={availableItems}
                                    setItemType={setItemType}
                                    itemType={itemType}
                                    gameData={gameData}
                                />
                            }
                            </div>
                            <div className='player-market-content'>
                                {
                                    (itemType === "tradeportal")
                                    ?
                                    <PlayerTradePortal
                                        gameData={gameData}
                                        playerData={playerData}
                                    />
                                    :
                                    <PlayerStore
                                        gameData={gameData}
                                        playerData={playerData}
                                        availableItems={availableItems}
                                        itemType={itemType}
                                        gameStats={gameStats}
                                        teamMembers={teamMembers}
                                        saleList={saleList}
                                        collections={collections}
                                    />
                                }
                            </div>
                            {/* {
                                (screenSize === 'mobile' || screenSize === 'tablet') &&
                                <div className='buttons'>
                                    <button className='g-button primary'>
                                        Go To Cart
                                    </button>
                                </div>
                            } */}
                        </div>
                    </div>
                }></Route>
                <Route path='shoppingcart' element={
                    <ShoppingCart
                        gameData={gameData} 
                        playerData={playerData} 
                        gameElements={availableItems}
                        gameStats={gameStats} 
                        teamMembers={teamMembers}
                        myTeams={myTeams}
                    />
                }></Route>
                
            </Routes>
            
        </div>
    )
}

export default PlayerMarketLanding;